import { Fragment } from "react";

export const CancelButton = ({ onClick, className = "", caption = "Cancel", type = "button" }) => {
  return (
    <Fragment>
      {type === "button" ? (
        <div className="product-button">
          <button type="button" className="btn btn-products btn-unavailable" onClick={onClick}>
            Cancel
          </button>
        </div>
      ) : (
        <div className="greyLink-btn border-link">
          <a
            role="button"
            className={className}
            onClick={(e) => {
              e.preventDefault();
              onClick();
            }}
          >
            {caption}
          </a>
        </div>
      )}
    </Fragment>
  );
};
